export default __webpack_public_path__ + "static/media/IMG_2722.7972c7af.jpg";